import { Box, CircularProgress } from '@mui/material';
import TimeSlotButtons from './time-slot-buttons';
import { Range } from './schedule';

interface TimePickerProps {
  morningTimeSlots: Range[];
  afternoonTimeSlots: Range[];
  selectedStartTime: string;
  setSelectedStartTime: (selectedStartTime: string) => void;
  setSelectedEndTime: (selectedEndTime: string) => void;
  disabled: boolean;
  loading?: boolean;
}

const TimePicker = ({
  morningTimeSlots,
  afternoonTimeSlots,
  selectedStartTime,
  setSelectedStartTime,
  setSelectedEndTime,
  disabled,
  loading,
}: TimePickerProps) => {
  if (loading)
    return (
      <Box
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <CircularProgress />
      </Box>
    );

  return (
    <>
      {morningTimeSlots?.length > 0 && (
        <TimeSlotButtons
          timeOfDay="AM"
          timeSlots={morningTimeSlots}
          selectedStartTime={selectedStartTime}
          setSelectedStartTime={setSelectedStartTime}
          setSelectedEndTime={setSelectedEndTime}
          disabled={disabled}
        />
      )}
      {afternoonTimeSlots?.length > 0 && (
        <TimeSlotButtons
          timeOfDay="PM"
          timeSlots={afternoonTimeSlots}
          selectedStartTime={selectedStartTime}
          setSelectedStartTime={setSelectedStartTime}
          setSelectedEndTime={setSelectedEndTime}
          disabled={disabled}
        />
      )}
    </>
  );
};

export default TimePicker;
